'use client';

import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { MenuClientHideConditions, ServerLink } from '../helpers';
import AboutUsButton from './AboutUsButton';
import { FooterMenuLinkClientWrapper } from './FooterMenuLinkClientWrapper';
import { Country } from '@/helpers/conf';
import useEstonia from '@/hooks/estonia';
import { useCurrentCountry } from '@/hooks/useCurrentCountry';
import { useCommonStore } from '@/store';

import { ScFooterItem, ScMenuBottom } from './styled';

type FooterMenuProps = {
  links: ServerLink[];
};

export const FooterMenu = ({ links }: FooterMenuProps) => {
  const { isEstonia } = useEstonia();
  const isAustralia = useCurrentCountry(Country.Australia);
  const { referralProgramData, project, projectPending } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      referralProgramData: state.referralProgramData,
      project: state.project,
      projectPending: state.projectPending,
    }))
  );

  const isReferralProgramAvailable = useMemo(
    () =>
      referralProgramData?.enable &&
      !projectPending &&
      project?.availableReferralSystem,
    [
      referralProgramData?.enable,
      projectPending,
      project?.availableReferralSystem,
    ]
  );

  const hideConditionResults = {
    [MenuClientHideConditions.IsEstonia]: isEstonia,
    [MenuClientHideConditions.IsNotEstonia]: !isEstonia,
    [MenuClientHideConditions.isReferralPage]: !isReferralProgramAvailable,
    [MenuClientHideConditions.IsAustralia]: isAustralia,
  };

  return (
    <ScFooterItem>
      <ScMenuBottom>
        {links.map(
          ({
            id,
            url,
            analyticsEventPayload,
            hideConditions,
            serverComponent,
          }) => (
            <FooterMenuLinkClientWrapper
              key={id}
              url={url}
              hideConditions={hideConditions}
              hideConditionResults={hideConditionResults}
              analyticsEventPayload={analyticsEventPayload}
            >
              {serverComponent}
            </FooterMenuLinkClientWrapper>
          )
        )}

        <li>
          <AboutUsButton />
        </li>
      </ScMenuBottom>
    </ScFooterItem>
  );
};
